import DateTimeDetailsFormRow, {
  date_format_dateTime,
} from "../../Common/DetailsForm/Presenter/DateTimeDetailsFormRow";
import DetailsFormRow from "../../Common/DetailsForm/Presenter/DetailsFormRow";
import MultilineDetailsFormRow from "../../Common/DetailsForm/Presenter/MultilineDetailsFormRow";
import ProductReturnRequestAttachmentDisplayFragment from "./ProductReturnRequestAttachmentDisplayFragment";
import ProductReturnRequestItemDisplayFragment from "./ProductReturnRequestItemDisplayFragment";
import type { productReturnRequestDisplayVM } from "./productReturnRequestDisplayVM";

export function DetailsPresenter(props: { object: productReturnRequestDisplayVM }) {
  return (
    <>
      <div className="-app-display-section">
        <h2>Dane podstawowe</h2>
        <DetailsFormRow
          label="Numer wniosku"
          value={props.object.code}
        ></DetailsFormRow>
        <DateTimeDetailsFormRow
          label="Utworzono"
          value={props.object.dateCreated}
          format={date_format_dateTime}
        ></DateTimeDetailsFormRow>
        <DetailsFormRow
          label="Stan wniosku"
          value={props.object.jobRouterStatus}
        ></DetailsFormRow>
        <DetailsFormRow
          label="Imię i nazwisko"
          value={props.object.customerRepName}
        ></DetailsFormRow>
        <DetailsFormRow
          label="Adres e-mail"
          value={props.object.customerRepEMail}
        ></DetailsFormRow>
        <DetailsFormRow
          label="Numer telefonu"
          value={props.object.customerRepPhone}
        ></DetailsFormRow>
        <DetailsFormRow
          label="Numer dokumentu sprzedaży"
          value={props.object.salesDocumentNumber}
        ></DetailsFormRow>
        {props.object.comments && (
          <MultilineDetailsFormRow
            label="Uwagi"
            text={props.object.comments}
          ></MultilineDetailsFormRow>
        )}
      </div>
      <div className="-app-display-section">
        <h2>Pozycje</h2>
        <ProductReturnRequestItemDisplayFragment
          items={props.object.items}
        ></ProductReturnRequestItemDisplayFragment>
      </div>
      {props.object.attachments.length > 0 && (
        <div className="-app-display-section">
          <h2>Załączniki</h2>
          <ProductReturnRequestAttachmentDisplayFragment
            items={props.object.attachments}
          ></ProductReturnRequestAttachmentDisplayFragment>
        </div>
      )}
    </>
  );
}

export default DetailsPresenter;
